import { render, staticRenderFns } from "./LatestExpertResponses.vue?vue&type=template&id=0869d110&scoped=true"
import script from "./LatestExpertResponses.vue?vue&type=script&lang=js"
export * from "./LatestExpertResponses.vue?vue&type=script&lang=js"
import style0 from "./LatestExpertResponses.vue?vue&type=style&index=0&id=0869d110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0869d110",
  null
  
)

export default component.exports